
import { Link } from 'react-router-dom';
import Button from '../../../components/base/Button';

export default function TeamSection() {
  const teamMembers = [
    {
      name: 'Dr. Sandhya',
      designation: 'General and Cosmetic Dentist',
      image: 'https://toothdoctor.in/wp-content/uploads/elementor/thumbs/sandhiya-q8ywhy4exkvzh53f4jl50qjghrfs6dlutl3rqdr8hy.jpg',
      description: 'Dr. Sandhya is a highly skilled and experienced dentist who leads the team at Tooth Doctor Clinic. With a passion for dentistry and a commitment to patient care, she has established herself as a trusted dental professional in the community.'
    },
    {
      name: 'Dr. N R Shrinivaasan',
      designation: 'M.D.S., Consultant Orthodontist Professor and Head of the department Department of orthodontics Dhanalakshmi Srinivasan dental college',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-5-768x779.jpg',
      description: 'Specialist in orthodontics with extensive experience in teeth alignment and bite correction treatments.'
    },
    {
      name: 'Dr. Shanmugasundaram',
      designation: 'MDS, FIBOMS, MBA (HOSPITAL Management), FAOCMF(GERMANY)',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/WhatsApp-Image-2023-07-07-at-11.13.28-AM-768x779.jpeg',
      description: 'Expert in oral and maxillofacial surgery with international qualifications and hospital management expertise.'
    },
    {
      name: 'Dr. K. Dhanadivya',
      designation: 'Consultant Periodontist Senior Lecturer, Department of Periodontics, Sri Ramachandra Dental college and Hospital, SRIHER',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-768x779.jpg',
      description: 'Specialist in periodontics focusing on gum health and supporting structures of teeth.'
    },
    {
      name: 'Dr. Suthanraj.AK',
      designation: 'MDS (OMFS) Association Professor Karpaga Vinayaga Institute of Dental Sciences',
      image: 'https://toothdoctor.in/wp-content/uploads/2023/07/tooth-doctor-2-768x779.jpg',
      description: 'Expert in oral and maxillofacial surgery with academic and clinical experience.'
    },
    {
      name: 'Dr. S. Riyaz Mohammed',
      designation: 'Periodontist & ORAL implantologist Member- IPS',
      image: 'https://toothdoctor.in/wp-content/uploads/2024/09/WhatsApp-Image-2024-09-23-at-7.53.13-PM-150x150.jpeg',
      description: 'Specialist in periodontics and oral implantology with membership in professional societies.'
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Meet Our Expert Team</h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Our team of experienced dentists and specialists are dedicated to providing you with the best possible care
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {teamMembers.map((member, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-square overflow-hidden">
                <img 
                  src={member.image} 
                  alt={member.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-4 sm:p-6">
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2">{member.name}</h3>
                <p className="text-[#012B53] font-medium mb-2 sm:mb-3 text-xs sm:text-sm leading-relaxed">{member.designation}</p>
                <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">{member.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-12">
          <Link to="/doctors">
            <Button variant="primary" size="lg" className="w-full sm:w-auto">
              View All Doctors
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
